import React, { useCallback, useEffect, useState } from "react";
import FavoritesTable from "../../library/FavoritesTable/FavoritesTable";
import { ToastType } from "../../ToastManager/constants";
import { sendNotification } from "../../ToastManager/ToastManager";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import {
  mapDispatchToProps,
  mapStateToProps,
  favoritesReducer,
} from "./FavoritesTable.store";
import CustomModal, {
  ModalSize,
} from "../../ui-library/CustomModal/CustomModal";
import { DietDairyTypes } from "../DietDiary/DietDiary.constants";
import FavoriteMeal from "../FavoriteMeal/FavoriteMeal";
import { useTranslation } from "react-i18next";

export const SmartFavoritesTable = (props) => {
  const {
    searchedParams,
    totalItems,
    favoriteMeals,
    fetchFavoriteMeals,
    canEditFavorites,
    canViewDetailFavorites,
    canCreateFavorites,
    resetState,
    studyId,
    loading,
  } = props;

  const { t } = useTranslation();

  const [selectedFavoriteMeal, setSelectedFavoriteMeal] = useState(null);
  const [favoriteMealModalTitle, setFavoriteMealModalTitle] = useState("");

  const getData = useCallback(
    (params) => {
      fetchFavoriteMeals(params).catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
    },
    [fetchFavoriteMeals]
  );

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  useEffect(() => {
    if (totalItems === null) {
      getData(searchedParams);
    }
  }, [getData, searchedParams, totalItems]);

  const onEditFavoriteMeal = (favorite) => {
    const type = JSON.parse(favorite.json)?.type ?? DietDairyTypes.FOOD_DRINK;

    setFavoriteMealModalTitle(`${t("appText.edit")} ${favorite.name}`);

    setSelectedFavoriteMeal({
      favoriteId: favorite.favoriteId,
      jsonData: favorite.json,
      date: favorite.date,
      type: type,
      readOnly: false,
      name: favorite.name,
      reasonForChange: favorite.reasonForChange,
    });
  };

  const onViewFavoriteMeal = (favorite) => {
    const type = JSON.parse(favorite.json)?.type ?? DietDairyTypes.FOOD_DRINK;

    setFavoriteMealModalTitle(`${t("appText.view")} ${favorite.name}`);

    setSelectedFavoriteMeal({
      favoriteId: favorite.favoriteId,
      jsonData: favorite.json,
      date: favorite.date,
      type: type,
      readOnly: true,
      name: favorite.name,
      reasonForChange: favorite.reasonForChange,
    });
  };

  const onCloseFavoriteMealModal = (refresh) => {
    setSelectedFavoriteMeal(null);

    if (refresh) {
      getData(searchedParams);
    }
  };

  return (
    <>
      <CustomModal
        show={selectedFavoriteMeal !== null}
        title={favoriteMealModalTitle ?? ""}
        size={ModalSize.large}
        onClose={() => onCloseFavoriteMealModal(false)}
      >
        <FavoriteMeal
          defaultItems={selectedFavoriteMeal?.defaultItems}
          type={selectedFavoriteMeal?.type}
          onSubmit={() => onCloseFavoriteMealModal(true)}
          readOnly={selectedFavoriteMeal?.readOnly}
          favoriteId={selectedFavoriteMeal?.favoriteId}
          mealJsonData={selectedFavoriteMeal?.jsonData}
          favoriteMeal={selectedFavoriteMeal}
          setModalTitle={setFavoriteMealModalTitle}
          existingReasonForChange={selectedFavoriteMeal?.reasonForChange}
          studyId={studyId}
        />
      </CustomModal>

      <FavoritesTable
        {...{ getData }}
        {...{ searchedParams }}
        totalitems={totalItems}
        loading={loading}
        favorites={favoriteMeals}
        {...{ canEditFavorites }}
        {...{ canViewDetailFavorites }}
        {...{ canCreateFavorites }}
        onAddNew={setSelectedFavoriteMeal}
        onEdit={onEditFavoriteMeal}
        onView={onViewFavoriteMeal}
        studyId={studyId}
      />
    </>
  );
};

export default dynamic(
  "favoritesReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(favoritesReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartFavoritesTable));
